import { DeceasedRecord, prettyTitle } from "@/types";
import { formatDate } from "@/utils/Functions";
import { FieldRow, FieldsTable, FieldsTableHeader } from "@/components/molecules/FieldsTable";
import { MARITAL_STATUS_MAP, MaritalStatus } from "@/types/Case";
import { propertyDetails } from "@/helpers/person-helpers";

export const DeceasedPersonalDetails = ({
  deceased,
  onEditDeceased,
  properties,
}: {
  deceased?: DeceasedRecord;
  onEditDeceased?: any;
  properties?: any;
}) => {
  return (
    <FieldsTable
      header={
        <FieldsTableHeader
          title="Details of the person who died"
          onEdit={onEditDeceased ?? (() => {})}
        />
      }
    >
      <FieldRow
        label="Name"
        value={`${prettyTitle(deceased?.title)} ${deceased?.firstName} ${deceased?.lastName}`}
      />

      {properties && (
        <FieldRow label="Address" value={propertyDetails(deceased?.propertyId, properties)} />
      )}

      <FieldRow label="Phone" value={deceased?.contactNumber ?? ""} />
      <FieldRow label="Email" value={deceased?.email ?? ""} />
      <FieldRow
        label="Date of birth"
        value={deceased?.dateOfBirth ? formatDate(deceased?.dateOfBirth) : ""}
      />
      <FieldRow
        label="Date of death"
        value={deceased?.dateOfDeath ? formatDate(deceased?.dateOfDeath) : ""}
      />
      {deceased?.maritalStatus && (
        <FieldRow
          label="Marital status"
          value={
            deceased?.maritalStatus
              ? MARITAL_STATUS_MAP[deceased?.maritalStatus as MaritalStatus]
              : "Unknown"
          }
        />
      )}
    </FieldsTable>
  );
};
